import React, { Component } from "react";
import PropTypes from "prop-types";
import i18n from "i18next";
import { templates } from "./templates/templates";
import "./_templatesModal.scss";
import AppModal from "../../common/modal/AppModal";
import TemplateThumbnailRich from "./TemplateThumbnailRich";

export default class TemplatesModalRich extends Component {
  constructor(props) {
    super(props);
    this.index = 0;
    this.templates = templates();
    /**
     * Component's initial state
     */
    this.state = {
      itemSelected: -1,
    };
  }
  render() {
    return (
      <AppModal
        id="TemplatesModalRich"
        show={this.props.show}
        onClose={() => this.closeModal()}
        title={<span id="previewTitle">{i18n.t("templates.templatechose")}</span>}
        cancelLabel={i18n.t("importFile.footer.cancel")}
        onCancel={() => this.closeModal()}
        confirmLabel={i18n.t("importFile.footer.ok")}
        onConfirm={() => {
          this.getBoxes(this.state.itemSelected);
          this.closeModal();
        }}
      >
        <div className="items_container">
          <div
            id="empty"
            className="template_item"
            key="-1"
            style={{
              width: "120px",
              height: "80px",
              border: this.state.itemSelected === -1 ? "solid #a963f5 3px" : "solid #eee 1px",
              position: "relative",
            }}
            onClick={(e) => {
              this.setState({
                itemSelected: -1,
              });
            }}
            onDoubleClick={(e) => {
              this.setState({
                itemSelected: -1,
              });
              this.AddNavItem(-1);
            }}
          >
            <div
              className={"template_name"}
              style={{ display: this.state.itemSelected === -1 ? "block" : "none" }}
            >
              {i18n.t("templates.template0")}
            </div>
          </div>
          {this.templates.map((item, index) => {
            let border = this.state.itemSelected === index ? "solid #a963f5 3px" : "solid #eee 1px";
            return (
              <div
                key={index}
                className="template_item"
                style={{ position: "relative", border: border, width: "120px", height: "80px" }}
              >
                <TemplateThumbnailRich
                  key={index}
                  index={index}
                  onClick={(e) => {
                    this.setState({ itemSelected: index });
                  }}
                  onDoubleClick={(e) => {
                    this.setState({ itemSelected: index });
                    this.AddNavItem(index);
                  }}
                  boxes={item.boxes}
                />
                <div
                  className={"template_name"}
                  style={{ display: this.state.itemSelected === index ? "block" : "none" }}
                >
                  {item.name}
                </div>
              </div>
            );
          })}
        </div>
      </AppModal>
    );
  }

  /**
   * Close modal
   */
  closeModal() {
    // reset state
    this.setState({ itemSelected: -1 });
    this.props.close();
  }

  getBoxes(itemSelected) {
    let boxes = [];
    if (itemSelected !== -1) {
      let selectedTemplate = this.templates[itemSelected];
      boxes = selectedTemplate.boxes;
    }
    this.props.templateClick(boxes);
  }
}
TemplatesModalRich.propTypes = {
  /**
   * Whether the import file modal should be shown or hidden
   */
  show: PropTypes.bool,
  /**
   * Closes import file modal
   */
  close: PropTypes.func.isRequired,
  /**
   * Function for getting template ID
   */
  templateClick: PropTypes.func.isRequired,
};
